import { Form } from 'antd';
import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { ChargeBalanceParams } from '../model/types';
import { useChargeBalance } from '../utils/hooks/useReplenishBalance';
import { BalanceModal } from './BalanceModal';

interface ChargeBalanceProps {
  userId: string;
  balance: number;
  action: ReactElement;
}

export const ChargeBalance: FC<ChargeBalanceProps> = memo((props) => {
  const { userId, balance, action } = props;

  const { t } = useAppTranslation('profile');

  const {
    isLoading,
    isOpenedConfirm,
    isOpenedBalance,
    chargeBalance,
    closeConfirmModal,
    openConfirmModal,
    closeBalanceModal,
    openBalanceModal,
  } = useChargeBalance();

  const [form] = Form.useForm();

  const handleChargeBalance = useCallback(async () => {
    const { amount, description }: ChargeBalanceParams = form.getFieldsValue();

    await chargeBalance({ userId, amount, description });

    form.resetFields();
  }, [form, chargeBalance, userId]);

  return (
    <>
      {React.cloneElement(action, { onClick: openBalanceModal })}
      <BalanceModal
        isOpened={isOpenedBalance}
        formInstance={form}
        isLoading={isLoading}
        onSubmit={openConfirmModal}
        onCancel={closeBalanceModal}
        balance={balance}
      />
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Charge from balance')}
        description={t('Are you sure you want to charge from balance?')}
        isLoading={isLoading}
        onOk={handleChargeBalance}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
